/** Админка видна только админам (сервер: SPREADBOT_ADMIN_USERS, флаг
 *  `is_admin` в /api/settings). Ручки /api/admin/* сервер закрывает сам. */
import type { UserSettings } from '../types';

export const isAdmin = (user: Pick<UserSettings, 'is_admin'> | null | undefined): boolean =>
  !!user?.is_admin;
